import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { lazy, Suspense } from 'react';
import DelayedLoader from '../DelayedLoader';
import { usePlayerWidth } from './hooks';
var AppContent = /*#__PURE__*/lazy(function () {
  return import(
  /* webpackChunkName: "plr" */
  '../AppContent');
});

var App = function App(_ref) {
  var playerWithFromProps = _ref.playerWidth,
      appProps = _objectWithoutProperties(_ref, ["playerWidth"]);

  var _usePlayerWidth = usePlayerWidth(playerWithFromProps),
      _usePlayerWidth2 = _slicedToArray(_usePlayerWidth, 2),
      playerRef = _usePlayerWidth2[0],
      playerWidth = _usePlayerWidth2[1];

  return __jsx("div", {
    ref: playerRef
  }, playerWidth && __jsx(Suspense, {
    fallback: __jsx(DelayedLoader, null)
  }, __jsx(AppContent, _objectSpread({
    playerWidth: playerWidth
  }, appProps))));
};

export default App;